import React, { useRef, useState } from "react";
import styled from "styled-components";
import { Button } from "semantic-ui-react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { addNotification } from "store/slices/uiSlice";
import { errorHandler } from "globalResources/util";

const Main = styled.div`
  display: flex;
  flex-direction: column;
`;

const Preview = styled.a``;

const FileUploader = ({ label, namePrefix, onKey, folder }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const ref = useRef();
  const dispatch = useDispatch();

  const onUpload = async (event) => {
    setLoading(true);
    if (event.target.files && event.target.files[0]) {
      let file = event.target.files[0];
      const key = namePrefix + file.name;

      try {
        const {
          data: { url, fields },
        } = await axios.post("/s3/presign-upload", {
          fileName: key,
          folder,
          contentType: file.type,
        });

        // Package everything into multi-part form-data
        const formData = new FormData();

        // Important: Loop through and attach all security tokens and fields first
        Object.entries(fields).forEach(([key, value]) => {
          formData.append(key, value);
        });

        // Attach the file last
        formData.append("file", file);

        const uploadRes = await fetch(url, {
          method: "POST",
          body: formData,
        });

        if (uploadRes.ok) {
          onKey(fields.key);
        } else {
          dispatch(
            addNotification({ message: "Upload to aws failed", type: "error" }),
          );
        }
      } catch (err) {
        const { message } = await errorHandler(err);
        dispatch(
          addNotification({
            message: message || "Upload failed",
            type: "error",
          }),
        );
      }
    }
  };

  return (
    <Main>
      {file && (
        <Preview href={file.url} target="_blank">
          {file.name}
        </Preview>
      )}
      <Button onClick={() => ref.current.click()}>{label}</Button>
      <input
        ref={ref}
        type="file"
        style={{ display: "none" }}
        onChange={onUpload}
      />
    </Main>
  );
};
export default FileUploader;
